import { render, staticRenderFns } from "./KkLink.vue?vue&type=template&id=57053313"
import script from "./KkLink.vue?vue&type=script&lang=js"
export * from "./KkLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports